import { IOfferSpendByOfferListTableLang } from '../../../types/lang'

export const offerSpendByOfferListTableLang: IOfferSpendByOfferListTableLang = {
	offer_spend_by_offer_list_table: {
		column_offer_id: 'Offer ID_ua',
		column_offer: 'Offer_ua',
		column_offer_in_group: 'Offer in Group_ua',
		column_country: 'Country_ua',
		column_amount: 'Amount_ua',
		column_date: 'Date_ua',
	}
}